import React from 'react';

import Plasticcratesinj from './Plasticcratesinj';
import Plasticratecontain from './Plasticratecontain';
import Longerscrew from './Longerscrew';
import Fbplastic from './Fbplastic';



const Fbseriesplast = () => {
    return (
        <div>
      <Plasticcratesinj />
            <Plasticratecontain />
            <Longerscrew />
            <Fbplastic />
        </div>
    );
};
export default Fbseriesplast;
